module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('span', [_vm._v("版本号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.version))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc21039a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ContentFooter.vue
// module id = 1659
// module chunks = 0